import { MiddlewareAPI, Dispatch, Action } from 'redux';
import { Actions } from './actions';
import { UPDATE_DOCTOR_ACCOUNTS, UPDATE_MY_PROFILE, UPDATE_MY_PROFILES } from './actions/login';
import {
    DELETE_DIAGNOSE,
    DELETE_MEDICATION,
    DELETE_SYMPTOM,
    UPSERT_MEDICATION,
    UPDATE_VITALS,
    UPSERT_DIAGNOSE,
    UPSERT_SYMPTOM,
    UPDATE_FOLLOWUP,
    SET_FOLLOWUP,
    UPSERT_ADVICE,
    FINISH_PRESCRIPTION,
    DELETE_ADVICE,
    DELETE_ADVICE_PERMANENTLY,
    EDIT_ADVICE,
    UPSERT_LAB_TEST,
    DELETE_LAB_TEST,
    UPDATE_EXAMINATION,
    UPDATE_EXAMINATION_FINDINGS,
    UNDO_ACTION,
    LOAD_PRESCRIPTION_TEMPLATE,
    CLEAR_PRESCRIPTION,
    DELETE_MEDICAL_HISTORY,
    CLEAR_MEDICAL_HISTORY,
    UPSERT_MEDICAL_HISTORY,
    UPDATE_PP_NOTES,
    UPDATE_PP_PRIVATE_NOTES,
    UPDATE_PATIENT,
    UPDATE_REFERAL,
    APPLY_DRAFT,
    UPSERT_DYFORM,
    UPDATE_PRINT_CONFIG,
    SWAP_PX_ELEMENTS,
    SWAP_MEDICAL_HISTORY_ELEMENTS,
    UPDATE_LAB_REFERAL,
    UPSERT_LAB_VITAL,
    DELETE_LAB_VITAL,
    SET_LAB_VITALS,
    DELETE_VITALS,
    CLEAR_VITALS,
    UPDATE_VITALS_V0,
    DELETE_DYFORM,
    UPDATE_DY_FORM_PRINT_CONFIG,
    COPY_LAB_VITAL_DATE,
    SET_VITALS,
    COPY_SINCE_IN_DY,
    COPY_SINCE_IN_SY,
    UPSERT_PRESCRIPTION,
    SANITIZE_PRESCRIPTION,
    SANITIZE_FINAL_PRESCRIPTION,
    UPSERT_ATTACHMENT,
    UPDATE_MEDICATIONS,
    UPDATE_LAB_TESTS,
    REPLACE_HE_MEDICATION,
    UPSERT_DENTAL_PROCEDURE,
    DELETE_DENTAL_PROCEDURE,
    COPY_DENTAL_PROCEDURE_DATE,
    DELETE_DENTAL_EXAMINATION,
    UPSERT_DENTAL_EXAMINATION,
    COPY_DENTAL_EXAMINATION_DATE,
    DELETE_DENTAL_EXAMINATIONS,
    UPSERT_ADMINISTERED_VACCINES,
    UPSERT_MILESTONES,
    CLEAR_ADMINISTERED_VACCINES,
    SET_MILESTONES,
    EDIT_DENTAL_EXAMINATIONS_GROUP,
    UPDATE_MILESTONE,
    COPY_REPEAT_ON_LAB_INVESTIGATIONS,
    COPY_TEST_ON_LAB_INVESTIGATIONS,
    UPSERT_ELEMENT,
    UPSERT_INJECTION,
    DELETE_INJECTION,
    SET_INJECTION_ELEMENTS,
    UPSERT_DENTAL_PROCEDURES,
    OP_FGP_COPY_FROM,
    setupPadGenieAutoSuggest,
    DELETE_ELEMENT,
    COPY_KEY_TO_ALL,
    UPSERT_IPD_ADMISSION,
    UPSERT_CARE_CANVAS,
    UPSERT_PRESCRIPTION_V2,
    UPSERT_CURRENT_MEDICATIONS,
} from './actions/prescriptionPad';
import { CREATE_VISIT } from './actions/visit';
import {
    addVisit,
    addPrescriptionIfNotExist,
    upsertPrescription,
    completeVisitById,
    updateLastVisitAndFollowUpInThePatient,
    updateDoctorProfile,
    updateLastOningVisitForPatient,
    upsertPrintConfig,
    getItemFromMisc,
    updateItemInMisc,
    updateDForms,
    deleteG,
    clearTable,
    QUOTA_EXCEEDED_ERR,
    getDoctorProfile,
    getMySingleDoctorId,
    getGArray,
    getGById,
} from './idbHandler';
import { GlobalState } from './reducers';
import { createFollowUpFromTemplate } from './reducers/prescriptionPad';
import { getTemplatizedFollowUp } from './genieReduxMiddleware';
import { Doctor } from './types/prescription';
import {
    ANSWER_SNACKING_QUESTION,
    UPDATE_ADD_PT_DY_FORM,
    UPDATE_GENIE_SETTINGS,
    UPSERT_CALCULATOR_CONFIG,
    UPSERT_GENIE_SETTINGS,
    UPSERT_MEDICAL_HISTORY_CONFIG,
    UPSERT_SECTION_NAME_CONFIG,
    UPSERT_VITALS_CONFIG,
} from './actions/session';
import {
    GCalculatorsConfig,
    GenieSettings,
    GMedicalHistoryConfig,
    GVitalConfig,
} from '../api/pushGenie';
import { pushGenieToBE } from './appReduxMiddleware';
import updateAddPtDyForm from '../api/updateAddPtDyForm';
import { DB_TABLES } from './dbTables';
import { SectionNameConfig } from './db';
import { LS_DOCTOR_ACCOUNTS } from '../api/fetchDocAccounts';
import { captureError, captureErrorString } from '../pages/captureError';
import { track } from '../tracking';
import { getMyDbId } from '../api/mactiveid';
import { getDefiniteMActiveId, setMyProfileList } from './localstorage';
import { ThunkDispatch } from 'redux-thunk';
import { Appointment } from '../api/fetchAppointmentsV2';

const TRACKING_SOURCE_NEW_VISIT_BORROW = 'NEW_VISIT_BORROW';

const handleAction = async (
    action: Actions,
    state: GlobalState,
    dispatch: ThunkDispatch<GlobalState, null, Actions>,
): Promise<void> => {
    switch (action.type) {
        case CREATE_VISIT:
            {
                try {
                    const doc: Doctor | undefined = await getDoctorProfile(action.visit.docid);

                    if (!doc) {
                        console.error('Doc not found');
                        break;
                    }

                    let clinic = doc.profile.professional.clinics?.find(
                        (c) => c._id === action.visit.clinicId,
                    );

                    if (!clinic) {
                        const appt = await getGById<Appointment>(
                            getDefiniteMActiveId(),
                            DB_TABLES.appointments,
                            action.visit.id,
                        );

                        if (appt?.clinic_id) {
                            clinic = doc.profile.professional.clinics?.find(
                                (c) => c._id === appt?.clinic_id,
                            );
                            track('CREATE_VISIT: Clinic from Appointment', {
                                clinicId: clinic?._id,
                                appointmentClinicId: appt?.clinic_id,
                                visitClinicId: action.visit.clinicId,
                                aid: action.visit.id,
                                apt_docid: action.visit.docid,
                                rxid: action.visit.prescriptionId,
                            });
                        }
                    }

                    if (!clinic && doc.profile.professional.default_clinic) {
                        clinic = doc.profile.professional.clinics?.find(
                            (c) => c._id === doc.profile.professional.default_clinic,
                        );
                        track('CREATE_VISIT: Default Clinic', {
                            clinicId: clinic?._id,
                            defaultClinic: doc.profile.professional.default_clinic,
                            visitClinicId: action.visit.clinicId,
                            aid: action.visit.id,
                            apt_docid: action.visit.docid,
                            rxid: action.visit.prescriptionId,
                        });
                    }

                    if (
                        !clinic &&
                        doc.profile.professional.clinics &&
                        doc.profile.professional.clinics.length > 0
                    ) {
                        clinic = doc.profile.professional.clinics[0];
                        track('CREATE_VISIT: First Clinic', {
                            clinicId: clinic?._id,
                            defaultClinic: doc.profile.professional.default_clinic,
                            visitClinicId: action.visit.clinicId,
                            aid: action.visit.id,
                            apt_docid: action.visit.docid,
                            rxid: action.visit.prescriptionId,
                        });
                    }

                    if (!clinic) {
                        console.error('Doc clinic not found');
                        break;
                    }

                    const patientAbha =
                        clinic && Array.isArray(action.visit.patient?.abhaV2)
                            ? action.visit.patient?.abhaV2?.find((abha) => abha.cId === clinic?._id)
                            : action.visit.patient?.abha;

                    try {
                        const addP = await addPrescriptionIfNotExist({
                            id: action.visit.prescriptionId,
                            date: new Date(),
                            visitId: action.visit.id,
                            clinic: clinic,
                            doctor: doc,
                            patient: {
                                id: action.visit.patient.id,
                                localId: action.visit.patient.localId,
                                uuid: action.visit.patient.uuid,
                                profile: {
                                    personal: {
                                        name: [
                                            action.visit.patient.name.f,
                                            action.visit.patient.name.l,
                                        ]
                                            .filter(Boolean)
                                            .join(' '),
                                        phone: action.visit.patient.phone,
                                        age: action.meta.patient.age,
                                        gender: action.meta.patient.gender,
                                        bloodgroup: action.meta.patient.bloodgroup,
                                        onApp: action.meta.patient.onApp,
                                    },
                                },
                                formData: action.visit.patient.formData,
                                'health-ids': action.visit.patient['health-ids'],
                                abha: patientAbha,
                                relations: action.visit.patient['relations'],
                            },

                            symptoms: preparePxElements(action.meta.pxData?.symptoms),
                            diagnosis: preparePxElements(action.meta.pxData?.diagnosis),
                            medications: preparePxElements(action.meta.pxData?.medications),
                            procedures: preparePxElements(action.meta.pxData?.procedures),
                            labTests: preparePxElements(action.meta.pxData?.labTests),
                            labVitals: preparePxElements(action.meta.pxData?.labVitals),

                            followup: createFollowUpFromTemplate(
                                getTemplatizedFollowUp(action.meta.pxData?.followup),
                            ),
                            advices: preparePxElements(action.meta.pxData?.advices),
                            examinations: action.meta.pxData?.examinations,
                            vitals: action.meta.pxData?.vitals,
                            prescriptionNotes: action.meta.pxData?.prescriptionNotes,
                            privateNotes: action.meta.pxData?.privateNotes,
                            refer: action.meta.pxData?.refer,
                            labRefer: action.meta.pxData?.labRefer,
                            dyform: action.meta.pxData?.dyform,
                            meta: {
                                autoCopyStatus: action.meta.autoCopy ? 'REQUIRED' : 'NOT_REQUIRED',
                            },
                        });
                    } catch (err) {
                        console.error('error in adding rx', err);
                    }

                    try {
                        const addV = await addVisit(action.visit);
                    } catch (e) {
                        console.error('error in adding visit', e);
                    }

                    try {
                        const addPt = await updateLastOningVisitForPatient(
                            action.visit.patient.localId,
                            action.visit.id,
                        );
                    } catch (e) {
                        console.error('error in adding visit', e);
                    }

                    // await Promise.all([addP, addV, addPt]);

                    if (action.onSuccess) {
                        action.onSuccess(action.visit.prescriptionId);
                    }
                } catch (e) {
                    console.error('Create Visit action failed', e);
                    if (
                        (e as Error).message.includes('Key already exists in the object store') &&
                        action.onFailure
                    ) {
                        action.onFailure();
                    }
                }
            }
            break;
        case UPDATE_VITALS_V0:
        case UPDATE_VITALS:
        case SET_VITALS:
        case DELETE_VITALS:
        case CLEAR_VITALS:
        case UPSERT_SYMPTOM:
        case UPSERT_ELEMENT:
        case DELETE_ELEMENT:
        case COPY_KEY_TO_ALL:
        case OP_FGP_COPY_FROM:
        case DELETE_SYMPTOM:
        case UPSERT_DYFORM:
        case DELETE_DYFORM:
        case UPSERT_DIAGNOSE:
        case DELETE_DIAGNOSE:
        case UPSERT_MEDICATION:
        case UPDATE_MEDICATIONS:
        case DELETE_MEDICATION:
        case DELETE_INJECTION:
        case UPSERT_INJECTION:
        case SET_INJECTION_ELEMENTS:
        case UPDATE_FOLLOWUP:
        case SET_FOLLOWUP:
        case UPSERT_ADVICE:
        case DELETE_ADVICE:
        case DELETE_ADVICE_PERMANENTLY:
        case EDIT_ADVICE:
        case UPSERT_LAB_TEST:
        case UPDATE_LAB_TESTS:
        case DELETE_LAB_TEST:
        case UPDATE_EXAMINATION:
        case UPDATE_EXAMINATION_FINDINGS:
        case UNDO_ACTION:
        case LOAD_PRESCRIPTION_TEMPLATE:
        case UPSERT_MEDICAL_HISTORY:
        case DELETE_MEDICAL_HISTORY:
        case CLEAR_MEDICAL_HISTORY:
        case UPDATE_PP_NOTES:
        case UPDATE_PP_PRIVATE_NOTES:
        case CLEAR_PRESCRIPTION:
        case UPDATE_REFERAL:
        case UPDATE_LAB_REFERAL:
        case APPLY_DRAFT:
        case SWAP_PX_ELEMENTS:
        case SWAP_MEDICAL_HISTORY_ELEMENTS:
        case UPSERT_LAB_VITAL:
        case DELETE_LAB_VITAL:
        case SET_LAB_VITALS:
        case COPY_LAB_VITAL_DATE:
        case COPY_SINCE_IN_SY:
        case UPSERT_PRESCRIPTION:
        case UPSERT_PRESCRIPTION_V2:
        case SANITIZE_PRESCRIPTION:
        case COPY_SINCE_IN_DY:
        case UPSERT_ATTACHMENT:
        case SANITIZE_FINAL_PRESCRIPTION:
        case REPLACE_HE_MEDICATION:
        case UPSERT_DENTAL_EXAMINATION:
        case DELETE_DENTAL_EXAMINATION:
        case DELETE_DENTAL_EXAMINATIONS:
        case COPY_DENTAL_EXAMINATION_DATE:
        case EDIT_DENTAL_EXAMINATIONS_GROUP:
        case UPSERT_DENTAL_PROCEDURE:
        case UPSERT_DENTAL_PROCEDURES:
        case DELETE_DENTAL_PROCEDURE:
        case UPSERT_ADMINISTERED_VACCINES:
        case UPSERT_MILESTONES:
        case CLEAR_ADMINISTERED_VACCINES:
        case SET_MILESTONES:
        case UPDATE_MILESTONE:
        case COPY_TEST_ON_LAB_INVESTIGATIONS:
        case COPY_REPEAT_ON_LAB_INVESTIGATIONS:
        case COPY_DENTAL_PROCEDURE_DATE:
        case UPSERT_IPD_ADMISSION:
        case UPSERT_CARE_CANVAS:
        case UPSERT_CURRENT_MEDICATIONS: {
            if (!state.prescriptionPad.prescription) return;

            await upsertPrescription(state.prescriptionPad.prescription);

            break;
        }
        case UPDATE_PATIENT:
            const rx = state.prescriptionPad.prescription || action.updatedRx;
            if (!rx) return;

            await upsertPrescription(rx);

            break;

        case FINISH_PRESCRIPTION:
            const prescription = action.px || state.prescriptionPad.prescription;
            if (!prescription) return;

            await completeVisitById(prescription.visitId);

            await updateLastVisitAndFollowUpInThePatient(
                prescription.patient.localId,
                prescription.followup?.date,
            );

            break;
        case UPDATE_MY_PROFILE:
            await updateDoctorProfile(action.profile);
            break;
        case UPDATE_DOCTOR_ACCOUNTS:
            try {
                localStorage.setItem(LS_DOCTOR_ACCOUNTS, JSON.stringify(action.accounts));
            } catch (e) {
                if ((e as Error).name == QUOTA_EXCEEDED_ERR.message) {
                    captureError(e as Error); // data wasn't successfully saved due to quota exceed so throw an error
                    track('QUOTA_EXCEEDED_ERR: Local Storage', {
                        key: LS_DOCTOR_ACCOUNTS,
                        length: String((action.accounts ?? []).length),
                    });
                }
            }
            break;
        case UPDATE_MY_PROFILES:
            setMyProfileList(action.profiles.users);
            break;
        case UPSERT_MEDICAL_HISTORY_CONFIG:
            const oid = action.oid || getMyDbId() || '';
            await updateItemInMisc<GMedicalHistoryConfig>(oid, 'medicalHistoryConfig', {
                ...action.medicalHistoryConfig,
            });
            await pushGenieToBE(oid, ['medicalHistoryConfig']);
            break;
        case UPSERT_CALCULATOR_CONFIG:
            await updateItemInMisc<GCalculatorsConfig>(getMyDbId() || '', 'calculatorConfig', {
                ...action.calculatorConfig,
            });
            await pushGenieToBE(getMyDbId() || '', ['calculatorConfig']);
            break;
        case UPSERT_SECTION_NAME_CONFIG:
            const docId = action.oid || getMySingleDoctorId() || '';
            await updateItemInMisc<SectionNameConfig>(docId, 'sectionNameConfig', {
                ...action.sectionNameConfig,
            });
            await pushGenieToBE(docId, ['sectionNameConfig']);
            break;
        case UPSERT_VITALS_CONFIG:
            await updateItemInMisc<GVitalConfig>(getMyDbId() || '', 'vitalsConfig', {
                ...action.vitalsConfig,
            });
            await pushGenieToBE(getMyDbId() || '', ['vitalsConfig']);
            break;

        case UPDATE_DY_FORM_PRINT_CONFIG:
            state.prescriptionPad.printConfigs &&
                (await upsertPrintConfig(getMyDbId() || '', state.prescriptionPad.printConfigs),
                await pushGenieToBE(getMyDbId() || '', ['printConfig']));
            break;
        case UPDATE_PRINT_CONFIG:
            await upsertPrintConfig(getMyDbId() || '', action.printConfigs);
            await pushGenieToBE(getMyDbId() || '', ['printConfig']);
            break;
        case UPDATE_GENIE_SETTINGS:
            const settings = await getItemFromMisc<GenieSettings>(getMyDbId() || '', 'settings');
            await updateItemInMisc<GenieSettings>(getMyDbId() || '', 'settings', {
                ...settings,
                [action.key]: action.value,
            });
            await pushGenieToBE(getMyDbId() || '', ['settings']);
            break;
        case UPSERT_GENIE_SETTINGS:
            const settings2 = await getItemFromMisc<GenieSettings>(
                action.oid || getMyDbId() || '',
                'settings',
            );
            await updateItemInMisc<GenieSettings>(action.oid || getMyDbId() || '', 'settings', {
                ...settings2,
                ...action.setting,
            });
            await pushGenieToBE(action.oid || getMyDbId() || '', ['settings']);
            if (action.setting.padElements) {
                dispatch(setupPadGenieAutoSuggest());
            }
            break;
        case UPDATE_ADD_PT_DY_FORM:
            const data = action.data;
            await updateDForms({ addp: data });
            await updateAddPtDyForm(data);
            break;
        case ANSWER_SNACKING_QUESTION: {
            if (action.q_id)
                deleteG(getMyDbId() || '', DB_TABLES['snackingQuestions'], action.q_id);
            else clearTable(getMyDbId() || '', DB_TABLES['snackingQuestions']);
            break;
        }
        default:
    }
};

const preparePxElements = <T>(array?: T[]): T[] | undefined =>
    array?.map((s) => ({
        ...s,
        track: { source: TRACKING_SOURCE_NEW_VISIT_BORROW },
    }));

const createIDBBackUpReduxMiddleware = () => (api: MiddlewareAPI<Dispatch, GlobalState>) => {
    return (next: Dispatch<Actions>) => (action: Action) => {
        const result = next(action);
        handleAction(action, api.getState(), api.dispatch).catch((err) => {
            console.log('backupMiddleware: Error handelling action', err);
            captureErrorString('backupMiddleware: Error handelling action ' + err.message);
        });
        return result;
    };
};

const idbBackUpReduxMiddleware = createIDBBackUpReduxMiddleware();

export default idbBackUpReduxMiddleware;
